import { Component } from '@angular/core';
import { LlmRunService } from './service/llmrun.service';

import { HttpErrorResponse } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-llm-run',
  templateUrl: './llm-run.component.html',
  styleUrl: './llm-run.component.scss'
})
export class LlmRunComponent {

    clientList:any=[];
    config_id:any;
    notifier:any;
  constructor(private llmrun:LlmRunService,  private notifierService: NotifierService,){
     this.notifier = notifierService;

  }

  ngOnInit(){


    this.llmrun.getCofig().subscribe({
      next:(res:any)=>{
       this.clientList = res;
      },
      error:(error:HttpErrorResponse)=>{

      }
    })
  }

  selectClient(event:any){
    console.log(event.target.value);
    if(event.target.value !="" || event.target.value!=undefined){
        this.config_id = event.target.value;
    }else{
 this.notifier.notify('default', 'Please select client');
    }
    
  }

  run_llm(source_type:any){
    if(this.config_id){
      this.llmrun.runAllLLM(this.config_id,source_type).subscribe({
          next:(res:any)=>{
              this.notifier.notify('default',res['message']);
          },
          error:(res:HttpErrorResponse)=>{

          }
        });
    }else{
     this.notifier.notify('default', 'Please select client');
    }
 
  }

}
